import React, { FC } from 'react'
import { useParams } from 'react-router-dom'
import { Col, Icon, Row, Typography } from 'antd'
import { serviceProviderService } from '../../services'
import { ServiceProvider, TabConfig } from '../../types'
import ChildAccounts from './ChildAccounts'
import { Page, RoutedTabs } from '../../components'
import Report from './Report'
import withEntityRequest from '../../components/withEntityRequest'
import RecurringInvoiceActions from '../../components/RecurringInvoiceActions'
import { useAuth } from '../../providers/AuthProvider'
import LicenseLimits from "../ServiceProvider/LicenseLimits";

const { Text, Title } = Typography

interface RouteParameters {
	id: string
	tab: string
}

interface ServiceProviderProps {
	entity: ServiceProvider
}

const ServiceProviderPage: FC<ServiceProviderProps> = ({ entity }) => {
	const { userHasPermission } = useAuth()
	const isMondagoAdmin = userHasPermission(['ServiceProvider.All.ReadWrite'])
	const tabs: TabConfig[] = [
		{
			id: 'children',
			title: (
				<>
					<Icon type='apartment' /> Resellers
				</>
			),
			render: (): React.ReactNode => <ChildAccounts id={entity.id} />
		},
		{
			id: 'report',
			title: (
				<>
					<Icon type='area-chart' /> Realtime Report
				</>
			),
			render: (): React.ReactNode => <Report serviceProviderId={entity.id} serviceProviderName={entity.name} />
		},
		{
			id: 'licenses',
			title: (
				<>
					<Icon type='pound' /> License Limits
				</>
			),
			render: (): React.ReactNode => <LicenseLimits id={entity.id} isMondagoAdmin={isMondagoAdmin} />
		}
	]

	return (
		<Page
			title={
				<Title>
					<Row gutter={24}>
						<Col sm={24} md={14} lg={16}>
							{entity.name} <Text type='secondary'>Service Provider</Text>
						</Col>
						<Col sm={24} md={10} lg={8}>
							{isMondagoAdmin && <RecurringInvoiceActions entity={entity} />}
						</Col>
					</Row>
				</Title>
			}
		>
			<RoutedTabs tabs={tabs} />
		</Page>
	)
}

const PageWithRequest = withEntityRequest(ServiceProviderPage, { type: 'Service Provider', getById: id => serviceProviderService.getById(id) })

const ServiceProviderPageWithRequest = (): JSX.Element => {
	const { id } = useParams<RouteParameters>()
	return <PageWithRequest id={parseInt(id, 10)} />
}

export default ServiceProviderPageWithRequest
